(() => {
  'use strict';
  if (window.BuyonikShop) return;
  const configNode = document.getElementById('by-shop-config');
  const dialog = document.getElementById('by-cart-dialog');
  if (!configNode || !dialog) return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch { return; }
  const text = config.text;
  let returnTerms = null;
  try { returnTerms = JSON.parse(document.getElementById('by-return-config')?.textContent || 'null'); } catch {}
  const checkoutReady = new WeakSet(), checkoutPending = new WeakSet();
  const returnDataByProduct = new Map((returnTerms?.entries || []).map(entry => [String(entry.productId), entry]));
  const root = config.root.endsWith('/') ? config.root : config.root + '/';
  const toast = document.querySelector('[data-by-cart-toast]');
  const lines = dialog.querySelector('[data-by-cart-lines]');
  const errorBox = dialog.querySelector('[data-by-cart-error]');
  let cart = null, queue = Promise.resolve(), busy = 0, opener = null, toastTimer, readVersion = 0;
  const escape = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const money = value => new Intl.NumberFormat(config.locale === 'en' ? 'en-CA' : 'fr-CA', {style:'currency',currency:cart?.currency || config.currency || 'CAD'}).format(Number(value || 0) / 100);
  const cartError = message => { errorBox.textContent = message || ''; errorBox.hidden = !message; };
  function notify(message, error = false) {
    clearTimeout(toastTimer);
    toast.querySelector('[data-by-cart-toast-text]').textContent = message;
    toast.hidden = false;
    if (error && dialog.open) cartError(message);
    toastTimer = setTimeout(() => { if (!toast.contains(document.activeElement)) toast.hidden = true; }, 7000);
  }
  function updateBadge() {
    if (!cart) return;
    const count = cart.item_count;
    document.querySelectorAll('[data-by-cart-count]').forEach(node => { node.textContent = String(count); node.hidden = count === 0; });
    document.querySelectorAll('a[data-by-cart-open]').forEach(link => link.setAttribute('aria-label', text.cart + ' — ' + count + ' ' + (count === 1 ? text.item : text.items)));
    dialog.querySelector('[data-by-cart-dialog-count]').textContent = count ? '(' + count + ')' : '';
  }
  function safeUrl(value, image = false) {
    try {
      const url = new URL(value, location.origin);
      if (!['http:', 'https:'].includes(url.protocol) || (!image && url.origin !== location.origin)) return '';
      return url.href;
    } catch { return ''; }
  }
  function productUrl(item) {
    const raw = safeUrl(item.url);
    if (!raw) return root;
    const url = new URL(raw);
    if (item.properties?._Boutique === 'merchant') url.searchParams.set('view', 'by-paper-marchand');
    return url.pathname + url.search;
  }
  function itemReturns(item) {
    if (!returnTerms) return {text:'',short:''};
    const current = returnDataByProduct.get(String(item.product_id)) || {};
    const saved = item.properties?.[returnTerms.key] || item.properties?.[returnTerms.legacyKey];
    return {
      text: saved || current.text || '',
      short: item.properties?.[returnTerms.summaryKey] || ((!saved || saved === current.text) ? current.short : '') || ''
    };
  }
  function renderCart() {
    if (!cart) return;
    updateBadge();
    dialog.querySelector('[data-by-cart-footer]').hidden = cart.item_count === 0;
    dialog.querySelector('[data-by-cart-total]').textContent = money(cart.total_price);
    if (!cart.item_count) {
      lines.innerHTML = `<div class="by-cart-empty"><svg viewBox="0 0 28 28" fill="none" stroke="currentColor" stroke-width="1.3" aria-hidden="true"><path d="M2 4h4l3 14h14l3-10H7M10 21h12"/><circle cx="11" cy="25" r="1"/><circle cx="22" cy="25" r="1"/></svg><h3>${escape(text.empty)}</h3><p>${escape(text.empty_note)}</p><button type="button" class="by-cart-continue" data-by-cart-close>${escape(text.continue)}</button></div>`;
    } else {
      lines.innerHTML = cart.items.map(item => {
        const key = escape(item.key), name = escape(item.product_title || item.title);
        const image = safeUrl(item.featured_image?.url || item.image, true);
        const details = item.variant_title && item.variant_title !== 'Default Title' ? `<p class="by-cart-variant">${escape(item.variant_title)}</p>` : '';
        let properties = Object.entries(item.properties || {}).filter(([key,value]) => !key.startsWith('_') && value && key !== returnTerms?.legacyKey).map(([key,value]) => `<p class="by-cart-variant">${escape(key)}: ${escape(value)}</p>`).join('');
        const conditions = itemReturns(item);
        if (conditions.text) {
          const fullDetails = `<p>${escape(conditions.text).replace(/\n/g,'<br>')}</p><a href="${escape(safeUrl(returnTerms.policyUrl))}">${escape(returnTerms.linkLabel)}</a>`;
          properties += conditions.short
            ? `<div class="by-return-terms"><p class="by-return-preview">${escape(conditions.short)}</p><details class="by-return-details"><summary>${escape(returnTerms.detailsLabel)}</summary><div class="by-return-details-body">${fullDetails}</div></details></div>`
            : `<div class="by-return-terms">${fullDetails}</div>`;
        }
        const plan = item.selling_plan_allocation?.selling_plan?.name;
        return `<article class="by-cart-line" data-by-cart-line="${key}">${image ? `<a href="${escape(productUrl(item))}" tabindex="-1" aria-hidden="true"><img class="by-cart-line-image" src="${escape(image)}" alt="" width="85" height="105"></a>` : '<span></span>'}<div><h3><a href="${escape(productUrl(item))}">${name}</a></h3>${details}${properties}${plan ? `<p class="by-cart-variant">${escape(plan)}</p>` : ''}<div class="by-cart-line-bottom"><div class="by-cart-quantity" role="group" aria-label="${escape(text.quantity)} — ${name}"><button type="button" data-by-cart-change="${key}" data-delta="-1" aria-label="${escape(text.decrease)} — ${name}">−</button><span>${item.quantity}</span><button type="button" data-by-cart-change="${key}" data-delta="1" aria-label="${escape(text.increase)} — ${name}">+</button></div><strong class="by-cart-line-price">${money(item.final_line_price)}</strong></div><button class="by-cart-remove" type="button" data-by-cart-change="${key}" data-remove aria-label="${escape(text.remove)} — ${name}">${escape(text.remove)}</button></div></article>`;
      }).join('');
    }
    setBusy();
  }
  function setBusy() {
    dialog.querySelectorAll('[data-by-cart-change],[data-by-cart-checkout]').forEach(button => { button.disabled = busy > 0; });
    dialog.setAttribute('aria-busy', String(busy > 0));
  }
  async function request(path, options = {}) {
    const response = await fetch(root + path, {credentials:'same-origin',cache:'no-store',...options});
    let data;
    try { data = await response.json(); } catch { throw new Error(text.connection_error); }
    if (!response.ok || data.status >= 400) throw new Error(typeof data.description === 'string' ? data.description : typeof data.message === 'string' ? data.message : text.connection_error);
    return data;
  }
  async function loadReturnData(currentCart, force = false) {
    if (!returnTerms || !currentCart.items.length) return;
    if (!force && currentCart.items.every(item => returnDataByProduct.has(String(item.product_id)) || (item.properties?.[returnTerms.key] && item.properties?.[returnTerms.summaryKey]))) return;
    const url = new URL(root + 'cart', location.origin);
    url.searchParams.set('section_id', 'by-cart-return-data');
    if (returnTerms.previewTheme) url.searchParams.set('preview_theme_id', String(returnTerms.previewTheme));
    const response = await fetch(url.href, {credentials:'same-origin',cache:'no-store',signal:AbortSignal.timeout(15000)});
    if (!response.ok) throw new Error(text.connection_error);
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const node = html.querySelector('[data-by-return-data]');
    if (!node) throw new Error(text.connection_error);
    const entries = JSON.parse(node.textContent);
    if (!Array.isArray(entries)) throw new Error(text.connection_error);
    entries.forEach(entry => returnDataByProduct.set(String(entry.productId), {text:String(entry.text || ''),short:String(entry.short || '')}));
  }
  async function refresh() {
    const version = ++readVersion;
    const result = await request('cart.js');
    if (version !== readVersion) return;
    await loadReturnData(result);
    if (version !== readVersion) return;
    cart = result;
    if (dialog.open) renderCart(); else updateBadge();
  }
  function enqueue(work) {
    busy += 1;
    readVersion += 1;
    setBusy();
    const task = queue.then(work);
    queue = task.catch(() => {}).finally(() => { busy -= 1; setBusy(); });
    return task;
  }
  async function openCart(trigger) {
    opener = trigger || document.activeElement;
    if (!dialog.open) dialog.showModal();
    document.documentElement.classList.add('by-cart-open');
    toast.hidden = true;
    cartError('');
    if (cart) renderCart();
    try { await queue; await refresh(); } catch { cartError(text.connection_error); }
  }
  function closeCart() { dialog.close(); }
  dialog.addEventListener('close', () => {
    document.documentElement.classList.remove('by-cart-open');
    if (opener?.isConnected) opener.focus({preventScroll:true});
  });
  dialog.addEventListener('click', event => { if (event.target === dialog) { const bounds = dialog.getBoundingClientRect(); if (event.clientX < bounds.left || event.clientX > bounds.right) closeCart(); } });
  async function add(form, submitter) {
    if (form.dataset.byAdding === 'true') return;
    form.dataset.byAdding = 'true';
    const button = submitter || form.querySelector('[type="submit"]');
    const originalLabel = button?.textContent;
    const data = new FormData(form);
    data.delete('return_to');
    if (button) { button.disabled = true; button.textContent = text.adding; }
    let status = form.querySelector('[data-by-add-status]');
    if (!status) { status = document.createElement('p'); status.className = 'by-add-status'; status.dataset.byAddStatus = ''; status.setAttribute('role','status'); form.append(status); }
    status.textContent = '';
    status.classList.remove('is-error');
    let added = false;
    try {
      await enqueue(async () => {
        await request('cart/add.js', {method:'POST',body:data});
        added = true;
        try { await refresh(); } catch { status.textContent = text.added_check; notify(text.added_check); return; }
        status.textContent = text.added;
        notify(text.added);
      });
    } catch (error) {
      status.textContent = added ? text.added_check : error.message || text.connection_error;
      status.classList.toggle('is-error', !added);
      notify(status.textContent, !added);
      try { await refresh(); } catch {}
    } finally {
      form.dataset.byAdding = 'false';
      if (button) { button.disabled = false; button.textContent = originalLabel; }
    }
  }
  document.addEventListener('submit', event => {
    const form = event.target;
    if (form instanceof HTMLFormElement && event.submitter?.name === 'checkout' && returnTerms && /\/cart\/?$/.test(new URL(form.action, location.origin).pathname)) {
      if (checkoutReady.has(form)) { checkoutReady.delete(form); return; }
      event.preventDefault();
      event.stopImmediatePropagation();
      if (checkoutPending.has(form)) return;
      checkoutPending.add(form);
      const submitter = event.submitter;
      enqueue(async () => {
        cart = await request('cart.js');
        await loadReturnData(cart, true);
        let remainingUpdates = cart.items.length;
        while (true) {
          const item = cart.items.find(line => {
            const conditions = itemReturns(line);
            return conditions.text && (!line.properties?.[returnTerms.key] || Object.prototype.hasOwnProperty.call(line.properties || {},returnTerms.legacyKey) || (conditions.short && !line.properties?.[returnTerms.summaryKey]));
          });
          if (!item) break;
          if (remainingUpdates-- <= 0) throw new Error(text.connection_error);
          const conditions = itemReturns(item);
          const properties = {...item.properties,[returnTerms.key]:conditions.text};
          delete properties[returnTerms.legacyKey];
          if (conditions.short) properties[returnTerms.summaryKey] = conditions.short;
          cart = await request('cart/change.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:item.key,quantity:item.quantity,properties})});
        }
        if (dialog.open) renderCart();
      }).then(async () => {
        await queue;
        checkoutPending.delete(form);
        checkoutReady.add(form);
        form.requestSubmit(submitter);
      }).catch(error => {
        checkoutPending.delete(form);
        notify(error.message || text.connection_error, true);
      });
      return;
    }
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-by-ajax-add]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (!form.reportValidity()) return;
    add(form, event.submitter);
  }, true);
  document.addEventListener('click', event => {
    const target = event.target.closest('[data-by-cart-open],.by-paper-cart,.by-med-cart-link');
    if (target && !event.ctrlKey && !event.metaKey && !event.shiftKey && event.button === 0) {
      event.preventDefault(); event.stopImmediatePropagation(); openCart(target); return;
    }
    if (event.target.closest('[data-by-cart-close]')) { closeCart(); return; }
    if (event.target.closest('[data-by-toast-close]')) { toast.hidden = true; return; }
    const change = event.target.closest('[data-by-cart-change]');
    if (change && cart && !busy) {
      const key = change.dataset.byCartChange;
      const item = cart.items.find(item => item.key === key);
      if (!item) return;
      const quantity = change.hasAttribute('data-remove') ? 0 : Math.max(0, item.quantity + Number(change.dataset.delta));
      const delta = change.dataset.delta;
      cartError('');
      let next;
      enqueue(async () => {
        readVersion += 1;
        cart = await request('cart/change.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity})});
        renderCart();
        const line = [...dialog.querySelectorAll('[data-by-cart-line]')].find(row => row.dataset.byCartLine === key);
        next = line?.querySelector('[data-delta="' + delta + '"]') || dialog.querySelector('[data-by-cart-close]');
      }).then(async () => { await queue; next?.focus({preventScroll:true}); }).catch(async error => { cartError(error.message); try { await refresh(); } catch {} });
    }
  }, true);
  function syncDepartments() {
    document.querySelectorAll('[data-merchant-shop] [data-by-department="paper"]').forEach(link => link.setAttribute('aria-current', 'page'));
  }
  const header = document.querySelector('header.header');
  const measure = () => { if (header) document.documentElement.style.setProperty('--by-header-height', Math.ceil(header.getBoundingClientRect().height) + 'px'); };
  if (header && typeof ResizeObserver !== 'undefined') new ResizeObserver(measure).observe(header);
  window.addEventListener('resize', measure);
  window.addEventListener('hashchange', () => { if (dialog.open) closeCart(); requestAnimationFrame(syncDepartments); });
  window.addEventListener('pageshow', () => { syncDepartments(); if (!busy) refresh().catch(() => {}); });
  window.addEventListener('focus', () => { if (!busy) refresh().catch(() => {}); });
  document.addEventListener('visibilitychange', () => { if (!document.hidden && !busy) refresh().catch(() => {}); });
  window.BuyonikShop = {refresh};
  measure(); syncDepartments(); refresh().catch(() => {});
})();


